/* eslint-disable react-hooks/exhaustive-deps */
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Ball from '../Ball/index';
import { InputWithButton } from '../InputWithButton';
import classes from './Wheel.module.scss'
import WheelCounter from '../WheelCounter';
import { motion, useAnimation } from "framer-motion";
import { useFullScreen, useGameSounds, useMediaQuery } from '@educaplay/core';
import clsx from 'clsx';
import { wait } from '../../utils/promise';
import { useSelector, useDispatch } from "react-redux";
import { Slot, Clock } from '@educaplay/core/components';
import { skipQuestion } from "@educaplay/store/slices/gameSlice";
import { SCREENS } from '@educaplay/store/constants';

export const Wheel = forwardRef(function Wheel(props, ref) {

    const currentIndex = useSelector(state => state.game.currentIndex);
    const question = useSelector(state => state.game.questions[state.game.currentIndex]);
    const hasCountDown = useSelector(state => state.game.hasCountDown);
    const [isInputEmpty, setIsInputEmpty] = useState(true);
    const { gameRef, onAnswer } = props;
    const [angleCounter, setAngleCounter] = useState(0);
    const lives = useSelector(state => state.game.lives);
    const questions = useSelector(state => state.game.questions);
    const letters = useSelector(state => state.game.questions).map(({ text }) => text);
    const screen = useSelector(state => state.game.view);
    const liveActived = useSelector(state => state.game.liveActived);
    const specificAngle = angleCounter * (-360 / letters.length);
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const isLandscape = useMediaQuery("(orientation: landscape) and (max-width: 1024px)");
    const WhelRef = useRef();
    const composeRef = useRef();
    const inputButtonRef = useRef();
    const ballsParent = useRef();
    const [heightBall, setHeightBall] = useState(0);
    const [widthBall, setWidthBall] = useState(0);
    const [inputMobileHeight, setInputMobileHeight] = useState(0);
    const [mobileView, setMobileView] = useState(false);
    const gameSound = useGameSounds();
    const [isFullScreen] = useFullScreen();
    const animate = useAnimation();
    const dispatch = useDispatch()
    const isFirstTime = useRef(true);

    const introVariants = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.03
            }
        }
    }


    // useEffect(() => {

    //     if (!ballState.find(state => state.answered === false)) {
    //         finishHandler();
    //     }

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [ballState])


    const onFocusInputMobile = () => {
        setMobileView(true);
    }

    const onBlurInputMobile = () => {
        setMobileView(false);
        document.activeElement.blur();
    }

    useEffect(() => {

        const handleResize = () => {
            setHeightBall((WhelRef.current.getBoundingClientRect().height - 80) / 2);
            setWidthBall((((2 * Math.PI * ((WhelRef.current.getBoundingClientRect().height - 80) / 2)) / letters.length) - 2));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setHeightBall((WhelRef.current.getBoundingClientRect().height - 80) / 2);
        setWidthBall((((2 * Math.PI * ((WhelRef.current.getBoundingClientRect().height - 80) / 2)) / letters.length) - 2));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [WhelRef.current?.getBoundingClientRect().height, isFullScreen, isLandscape]);

    const onSubmit = async (writtenWord) => {
        if (screen === SCREENS.SCORE_SCREEN || lives <= 0) return;

        if (writtenWord) {
            onAnswer(writtenWord, { showFeedback: !(question.checkAnswer(writtenWord) && !liveActived) });
            await wait(800);
        } else {
            dispatch(skipQuestion());
        }
    }

    useEffect(() => {
        if (isFirstTime.current) {
            isFirstTime.current = false;
            return;
        }
        const prevIndex = angleCounter % questions.length;
        const angleSum = currentIndex - prevIndex + (currentIndex < prevIndex ? questions.length : 0); //calculates addition to angleCounter as (newIndex - prevIndex). If diff is negative, add number of letters (adds a complete rotation)
        setAngleCounter(angleCounter => angleCounter + angleSum);

        if (!questions[prevIndex].answer) gameSound.play('wheel-letterActive');

        setTimeout(() => {
            if (isTouchDevice) gameSound.play('wheel-rotate');
        }, 200)
    }, [currentIndex])

    useEffect(() => {
        const handleKeyPress = async (e) => {
            if (e.key === 'ArrowRight') {
                if (screen === SCREENS.SCORE_SCREEN || lives <= 0 || !isInputEmpty) return;
                dispatch(skipQuestion());
                await wait(800);
            }
        }

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        }


    }, [lives, screen, isInputEmpty])

    useEffect(() => {
        if (lives <= 0) {
            setMobileView(false);
            document.activeElement.blur();
        }

    }, [lives])

    useImperativeHandle(ref, () => ({
        animateEntry: async () => {
            await animate.start('show');
            await inputButtonRef.current.animateEntry();
        }
    }));


    useEffect(() => {
        if (!isTouchDevice && mobileView) return;

        const heightTimeOut = setTimeout(() => {
            if (!mobileView) {
                const mobileHeight = (composeRef.current?.getBoundingClientRect().height - (WhelRef.current.getBoundingClientRect().top - gameRef.current.getBoundingClientRect().top) + 10); // +10 es el espaciado que he decidido dejarle. Modificar el valor para dejar mas espacio entre el input top y la ruleta
                setInputMobileHeight(mobileHeight);
            }
        }, 300);

        return () => {
            clearTimeout(heightTimeOut);
        }

    }, [isTouchDevice, isFullScreen, isLandscape, mobileView])

    const rotateDuration = 1;

    const wheelWrapperStyle = mobileView ? { transform: 'translateY(' + inputMobileHeight + 'px)' } : {};

    return (
        <>
            <div className={classes.InputTopContainer} style={{ opacity: (mobileView ? 1 : 0), pointerEvents: (mobileView ? 'all' : 'none') }}>
                <Slot name="InputTop" />
            </div>
            <div className={classes.wheelWrapper} ref={WhelRef} style={wheelWrapperStyle}>
                <div className={classes.WrapperCircle} style={{ height: heightBall * 2 }}>
                    <div className={classes.counterWrapper} >
                        <WheelCounter className={classes.counter} currentBall={currentIndex}
                            ballNum={letters.length} specificAngle={specificAngle} ballMeasuraments={(widthBall > 48) ? 46 : widthBall} />
                    </div>

                    <div className={clsx(classes.clockContainer, (hasCountDown && question.time <= 60) && classes['clockContainer--countdown'])} style={{ opacity: mobileView ? 1 : 0 }}>
                        <Clock silenced />
                    </div>
                </div>

                <motion.div animate={isTouchDevice && { rotate: specificAngle }} transition={isTouchDevice && { duration: rotateDuration }} className={classes.wheelRotator} >
                    <motion.div initial='hidden' animate={animate} ref={ballsParent} className={classes.wheel} variants={introVariants}>
                        {questions.map((question, key) => {
                            const degrees = -90 + 360 / questions.length * key;
                            return (
                                <Ball
                                    widthBall={widthBall}
                                    heightBall={heightBall}
                                    degrees={degrees}
                                    specificAngle={isTouchDevice ? specificAngle : 0}
                                    rotateDuration={rotateDuration}
                                    key={key}
                                    className={
                                        clsx(
                                            currentIndex === key && classes['ball--selected'],
                                            (question.answer !== null && question.checkAnswer(question.answer)) && classes['ball--correct'],
                                            (question.answer !== null && !question.checkAnswer(question.answer)) && classes['ball--wrong']
                                        )}
                                >
                                    {question.text}
                                </Ball>
                            );
                        })}
                    </motion.div>
                </motion.div>

                <InputWithButton
                    mobileView={mobileView}
                    ref={inputButtonRef}
                    onSubmit={onSubmit}
                    setInputEmpty={setIsInputEmpty}
                    heightBall={heightBall}
                    onFocus={onFocusInputMobile} onBlur={onBlurInputMobile} composeRef={composeRef} />

            </div>
        </>
    )
})